import SdkServices from "../defaults/sdk/SdkServices";
import { BODY_MEASUREMENT_CONFIG, AUTO_TAGGING_CONFIG, VISUAL_CLOTHES_SEARCH_CONFIG, GARMENT_MEASUREMENT_CONFIG } from "../config/service-configs";
import { ServiceConfig } from "../types/unified-services";

export const getSdkServiceConfig = (serviceType: string): ServiceConfig => {
  switch (serviceType) {
    case SdkServices.BODY_MEASUREMENT:
    case SdkServices.SIZE_MEASUREMENT:
      return BODY_MEASUREMENT_CONFIG;

    case SdkServices.AUTO_TAGGING:
      return AUTO_TAGGING_CONFIG;

    case SdkServices.VISUAL_SEARCH:
      return VISUAL_CLOTHES_SEARCH_CONFIG;

    case SdkServices.GARMENT_MEASUREMENT:
      return GARMENT_MEASUREMENT_CONFIG;

    default:
      return BODY_MEASUREMENT_CONFIG;
  }
};

export const isValidSdkServiceType = (serviceType: string): boolean => {
  const validTypes = Object.values(SdkServices);
  return validTypes.includes(serviceType);
};
